import { useSelector } from 'react-redux';

export const useResolveCompanyInfo = (options = {}) => {
    const {
        selectedCompanyId,
        companyInfo,
        companyViewSelectedId,
        companyViewInfo,
        companyViewActive,
        configuration
    } = useSelector((state) => state.sessionState);

    const {
        id_company,
        select_company,
        id_user_action
    } = useSelector((state) => state.sharedViews);

    const companySelected = companyViewActive ? companyViewInfo : companyInfo;
    const companySelectedId = companyViewActive ? companyViewSelectedId : selectedCompanyId;

    return {
        id_user_action,
        companyViewActive,
        companySelected,
        companySelectedId,
        id_company: companySelectedId,
        select_company: companyViewActive,
        configuration
    };
};

export default useResolveCompanyInfo;